import React from "react";

const TranslationServ = () => {
  return (
    <div className="transHeadContent">
      <h2>
        Our <span>Translation</span> Services{" "}
      </h2>
      <p>
        Goodway Attestation offers a wide range of translation services,
        covering various languages and document types. Our certified translation
        service is a key differentiator, featuring accredited translators
        specializing in legal, medical, technical, and other fields. Whether you
        need certified translations for immigration, legal documents, or
        academic transcripts, we ensure accuracy and adherence to industry
        standards.
      </p>
    </div>
  );
};

export default TranslationServ;
